var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M97 127.8H59.4c-13.7 0-24.8-11.1-24.8-24.8 0-13.7 11.1-24.8 24.8-24.8.9 0 1.9.1 2.8.2-.1-1.2-.2-2.4-.2-3.6C62 57.2 76.2 43 93.7 43s31.8 14.2 31.8 31.8c0 1.3-.1 2.6-.2 3.9 1.4-.3 2.8-.5 4.3-.5 10.4 0 18.9 8.4 18.9 18.9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "OI_4L_main",
    cx: 135.9,
    cy: 116.5,
    rx: 27.9,
    ry: 10.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M163.8 116.5v25.2c0 5.9-12.5 10.6-27.9 10.6s-27.9-4.8-27.9-10.6v-12.6c0 5.9 12.5 10.6 27.9 10.6s27.9-4.8 27.9-10.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.728a5da6985ff93af755d3b9607b133e.svg";
export { ForwardRef as ReactComponent };